module.exports = __webpack_public_path__ + "img/3.ad46809b.jpeg";